import { apiSlice } from './apiSlice';
const ADMIN_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1/admin`;

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsersAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/user/getallusers`,
        method: 'Get',
        body: data,
        credentials: "include",
      }),
    }),
    createUserAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/user/create`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    updateUserAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/user/update`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),

    approveTransaction: builder.mutation({
      query: (id) => ({
        url: `${ADMIN_URL}/transaction-approve/${id}`,
        method: "PUT",
        credentials: "include",

      }),
    }),
    deleteUserAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/user/delete`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    getPaymentsAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/payment/getallpayments`,
        method: 'GET',
        body: data,
        credentials: "include",
      }),
    }),
    getSubsAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/subscription/getallsub`,
        method: 'GET',
        body: data,
        credentials: "include",
      }),
    }),
    getCourseAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/course/getallcourse`,
        method: 'GET',
        body: data,
        credentials: "include",
      }),
    }),
    deleteCourseAdminP: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/course/deletecourse`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
  }),
});

// Export hooks for usage in components
export const {
  useApproveTransactionMutation,
  useGetAllUsersAdminPMutation,
  useCreateUserAdminPMutation,
  useUpdateUserAdminPMutation,
  useDeleteUserAdminPMutation,
  useGetPaymentsAdminPMutation,
  useGetSubsAdminPMutation,
  useGetCourseAdminPMutation,
  useDeleteCourseAdminPMutation
} = adminApiSlice;
